import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import styles from './ModalStyles';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface Props extends WithStyles<typeof styles> {
  onClose: () => void;
  title?: string;
  content?: string;
}

const Clicked = (e: React.MouseEvent<HTMLElement>) => {
  e.stopPropagation();
};

function TextModal(props: Props) {
  const {classes, content, title} = props;
  return (
    <div
      className={classes.root}
      onClick={(e: React.MouseEvent<HTMLElement>) => Clicked(e)}
    >
      <Typography variant="h6" className={classes.title}>
        {title}
        <span
          className={classes.exit}
          onClick={() => props.onClose && props.onClose()}
        >
          +
        </span>
      </Typography>
      {content && (
        <div
          className={classes.info}
          dangerouslySetInnerHTML={{__html: content}}
        />
      )}
      <Button
        type="submit"
        variant="contained"
        color="primary"
        style={{
          width: '80%',
          right: 0,
          left: 0,
          margin: 'auto',
          marginBottom: '30px',
        }}
        className={`${classes.button} ${classes.buttonDown}`}
        onClick={() => props.onClose && props.onClose()}
      >
        Close
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{fontSize: '0.875rem', paddingLeft: '10px'}}
        />
      </Button>
    </div>
  );
}

export default withStyles(styles)(TextModal);
